import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=0709615b&scoped=true&"
import script from "./menu.vue?vue&type=script&lang=js&"
export * from "./menu.vue?vue&type=script&lang=js&"
import style0 from "./menu.vue?vue&type=style&index=0&id=0709615b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../mercari_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0709615b",
  null
  
)

export default component.exports